import {ID, Response} from '../../../../../../_metronic/helpers'
export type Company = {
  _id?: ID
  name?: string
  slug?: string
  createdAt? : string
  users? : []
  // avatar?: string
  // email?: string
  // status? : boolean
  // createdAt?: string
  // position?: string
  // role?: string
  // fullName? : string,
  // password? : string,
  // confirmpassword? : string
  // last_login?: string
  // two_steps?: boolean
  // joined_day?: string
  // online?: boolean
  // initials?: {
  //   label: string
  //   state: string
  // }
}

export type CompanyQueryResponse = Response<Array<Company>>

export const initialUser: Company = {
  // avatar: '/media/avatars/blank.png',
  // position: 'Art Director',
  // role: 'Super Admin',
  // firstName: '',
  // lastName: '',
  // email: '',
  // password : '',
  // confirmpassword : ''
  name: '',
  slug: '',
  createdAt : '',
  users : []
}
